<template>
    <section>
        <div class="py-5">
            <div class="container cards_section">
                <div class="row gx-5">
                    <div class="col-md-4">
                        <div @click="ToRecordsLocation" class="card shadow-sm p-2">
                            <h4 class="card-header rounded  text-center py-3 m-2"> <a href="#">أقرب سجل مدني</a> </h4>
                            <div class="card-body map_body">
                                <a href="#"> <img src="@/assets/images/google_map.jpg" alt="" class="img-fluid"> </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card shadow-sm p-2">
                            <h4 class="card-header rounded  text-center py-3 m-2"> <a href="#">مبادرات</a></h4>
                            <div class="card-body ">

                                <div id="initiativesٍSlider" class="carousel slide" data-bs-ride="true">
                                    <div class="carousel-indicators">
                                        <button type="button" data-bs-target="#initiativesٍSlider" data-bs-slide-to="0"
                                            class="active" aria-current="true" aria-label="Slide 1"></button>
                                        <button type="button" data-bs-target="#initiativesٍSlider" data-bs-slide-to="1"
                                            aria-label="Slide 2"></button>
                                        <button type="button" data-bs-target="#initiativesٍSlider" data-bs-slide-to="2"
                                            aria-label="Slide 3"></button>
                                    </div>
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <img src="@/assets/images/hyahKarima.jpg" class="img-fluid" alt="...">
                                        </div>
                                        <div class="carousel-item">
                                            <img src="@/assets/images/hyahKarima.jpg" class="img-fluid" alt="...">
                                        </div>
                                        <div class="carousel-item">
                                            <img src="@/assets/images/hyahKarima.jpg" class="img-fluid" alt="...">
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">

                        <div class="card shadow-sm p-2">

                            <h4 class="card-header rounded  text-center py-3 m-2"> <a href="#">استطلاع الرأى</a></h4>
                            <div class="card-body ">

                                <div class="row">
                                    <div class="col-12 fw-semibold">
                                        <p>ما مدى رضاك عن الخدمات الالكترونية المقدمة من القطاع؟
                                        </p>
                                    </div>

                                    <div v-for="vote in votingTypes" :key="vote.Id" class="custom-control custom-radio col-6">
                                        <input v-model="votingResult" class="custom-control-input" type="radio" name="flexRadioVoting" :id="vote.Id" >
                                        <label class="custom-control-label pointer" :for="vote.Id">{{vote.Name}}</label>                                     
                                    </div>

                                    <div class="col-12">
                                        <div class="d-flex justify-content-center">
                                            <button type="button" class="btn btn-light" @click="submit()"
                                                id="submit_Opinion" data-toggle="modal"
                                                data-target="#myModal">تصويت</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="popup" modal="popup" id="popup">
                            <img src="@/assets/images/tick.png">
                            <h2>شكرا</h2>
                            <button @click="closePopup">إغلاق </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import sharedData from '@/shared/sharedData';
import { debugError, debugLog } from "@/plugins/debug";
export default {
    name: 'CardsComp',
    data(){
        return{
            votingTypes: sharedData.voting_types,
            votingResult: '',
        }
    },

    methods: {
        ToRecordsLocation() {
            this.$router.push({ name: 'recordslocation' })
        },
        deselectAllRadios(){
            const radioButtons = document.querySelectorAll('input[name="flexRadioVoting"]');
                for (const radioButton of radioButtons) {radioButton.checked = false;}
        },
        closePopup() {
            let element = document.querySelector('.popup');
            element.classList.remove("open-popup");

            this.deselectAllRadios();
        },
        openPopUp() {
            let element = document.querySelector('.popup');
            element.classList.add("open-popup");
        },
        async AddVote(voteId){ 
            await this.$api.requests.AddVote(voteId)   
            .then(res => {      
                debugLog('====Add Vote Response========',res);  
                this.openPopUp();
            }).catch(err => {
                debugError(`${err}`);      
            });
        },
        submit() { 
            if (this.votingResult ==="on"){
                const radioButtons = document.querySelectorAll('input[name="flexRadioVoting"]');
                for (const radioButton of radioButtons) {
                    if (radioButton.checked) { this.AddVote(parseInt(radioButton.id));}
                }
            }else{this.$alerts.toast.error('لم يتم اختيار الصوت');}
        },


    }
}
</script>

<style>
.popup {
    width: 400px;
    background: #fff;
    border-radius: 6px;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%) scale(0.1);
    text-align: center;
    padding: 0 30px 30px;
    color: #333;
    visibility: hidden;
    transition: transform 0.4s, top 0.4s;
    z-index: 99 !important;
    border-color: #333;
    mask-border-width: 5px;
    box-shadow: 0 30px 30px 24px rgba(0, 0, 0, 0.5);
}

.open-popup {
    visibility: visible;
    top: 50%;
    transform: translate(-50%, -50%) scale(1);
}

.popup img {
    width: 100px;
    margin-top: -50px;
    border-radius: 50%;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.popup h2 {
    font-size: 38px;
    font-weight: 500;
    margin: 30px;
}

.popup button {
    width: 100%;
    margin-top: 35px;
    padding: 10px 0;
    /* background: #6fd649;*/
    background: #17479e;
    color: #fff;
    border: 0;
    outline: none;
    font-size: 30px;
    border-radius: 4px;
    cursor: pointer;
}
</style>